export default __webpack_public_path__ + "static/media/8.fc7da784.jpg";